import { render, staticRenderFns } from "./NarrationOnIcon.vue?vue&type=template&id=0659ada6&"
import script from "./NarrationOnIcon.vue?vue&type=script&lang=js&"
export * from "./NarrationOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports